var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.75C17.1544 13.75 16.875 14.0293 16.875 14.3749V16.8749H3.12503V14.3749C3.12503 14.0293 2.84503 13.75 2.50002 13.75C2.155 13.75 1.875 14.0293 1.875 14.3749V17.5C1.875 17.8456 2.155 18.1249 2.50002 18.1249H17.5C17.8456 18.1249 18.125 17.8456 18.125 17.5V14.3749C18.125 14.0293 17.8456 13.75 17.5 13.75ZM4.44492 10.3645L9.50566 15.4288C9.63004 15.5538 9.79256 15.6137 9.95443 15.6125C9.97631 15.6144 9.99506 15.625 10.0169 15.625C10.1082 15.625 10.1932 15.6038 10.2713 15.5688C10.3501 15.5388 10.4251 15.4931 10.4888 15.4294L15.5538 10.3684C15.7982 10.1246 15.7988 9.72904 15.5545 9.48465C15.4326 9.36215 15.2726 9.30092 15.112 9.3009C14.952 9.3009 14.7926 9.36215 14.6701 9.4834L10.642 13.51V2.49998C10.642 2.15436 10.362 1.875 10.017 1.875C9.67195 1.875 9.39195 2.15436 9.39195 2.49998V13.5406L5.33121 9.4832C5.20931 9.3607 5.04808 9.29883 4.88808 9.29883C4.72808 9.29883 4.56933 9.35943 4.44746 9.48068C4.20185 9.72383 4.20123 10.1201 4.44498 10.3644L4.44492 10.3645Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e36a2d59f6a0336e0b765d314b6eab10.svg";
export { ForwardRef as ReactComponent };